<template>
  <v-app light>
    <AppHeader :navItems="navItems"/>
    <router-view></router-view>
    <AppFooter :navShortcuts="navShortcuts"/>
  </v-app>
</template>

<script>
import nav from '../_nav'
import { Header as AppHeader, Footer as AppFooter } from '../components/'
import { mapGetters } from 'vuex'

export default {
  name: 'full',
  components: {
    AppHeader,
    AppFooter
  },
  data () {
    return {
      navItems: nav.items,
      navShortcuts: nav.shortcuts,
      title: 'Coffee Ketjil'
    }
  },
  created () {
    this.getRegions()
  },
  computed: {
    ...mapGetters(['regions'])
  },
  methods: {
    getRegions () {
      this.$store.dispatch('getRegions', {
        success: () => {
          const mappedRegions = this.regions.map(region => ({
            name: region.name,
            url: `/outlets/list/${region.id}`,
            icon: 'map-marker'
          }))
          this.navItems.map(nav => {
            if (nav.name.toLowerCase() === 'outlets') {
              nav.childs = [...mappedRegions]
            }
          })
        },
        fail: () => {
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/Full.vue